import type { ReactNode, Ref } from 'react';
import styles from './Field.module.scss';

interface FieldProps {
  label: ReactNode;
  required?: boolean;
  error?: string | null;
  hint?: ReactNode;
  className?: string;
  children: ReactNode;
  htmlFor?: string;
  fieldRef?: Ref<HTMLLabelElement>;
}

export function Field({
  label,
  required,
  error,
  hint,
  className,
  children,
  htmlFor,
  fieldRef,
}: FieldProps): JSX.Element {
  const wrapperClass = [
    styles.field,
    error ? styles.invalid : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label
      className={wrapperClass}
      data-invalid={error ? 'true' : undefined}
      htmlFor={htmlFor}
      ref={fieldRef}
    >
      <span className={styles.labelText}>
        {label}
        {required ? <span aria-hidden> *</span> : null}
      </span>
      {children}
      {error ? (
        <span className={styles.error} role="alert">
          {error}
        </span>
      ) : hint ? (
        <span className={styles.hint}>{hint}</span>
      ) : null}
    </label>
  );
}
